import { FormInstance } from 'antd';
import { snakeCase } from 'lodash';
import React from 'react';
import { Form } from 'components/atoms/form';
import { TranslationKey, useTranslate } from 'hooks/use-translation';
import { Select } from './components';
import { DirectionOptions, ShiftByOptions } from './model';
import { useShiftDatesState } from './use-shift-dates-state';

export const ShiftDatesForm = ({ form }: { form?: FormInstance<any> }) => {
  const translate = useTranslate();
  const {
    count,
    onCountChange,
    options,
    shiftBy,
    onShiftByChange,
    direction,
    onDirectionChange,
  } = useShiftDatesState();

  return (
    <Form
      layout="inline"
      form={form}
      initialValues={{
        duration: 1,
        unit: ShiftByOptions[0],
        direction: DirectionOptions[0],
      }}
    >
      <Form.Item name="duration">
        <Select
          data-cy="shift.dates.duration"
          virtual={false}
          value={count}
          onChange={onCountChange}
          $width={48}
        >
          {options.map((option) => (
            <Select.Option
              key={option}
              value={option}
              title={option.toString()}
            >
              {option}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name="unit">
        <Select
          data-cy="shift.dates.unit"
          virtual={false}
          value={shiftBy}
          onChange={onShiftByChange}
          $width={72}
        >
          {ShiftByOptions.map((option) => {
            const translation = translate(
              `task_list.bulk_editor.options.shift_dates.shift_by.${snakeCase(
                option,
              )}` as TranslationKey,
            );

            return (
              <Select.Option key={option} value={option} title={translation}>
                {translation}
              </Select.Option>
            );
          })}
        </Select>
      </Form.Item>
      <Form.Item name="direction">
        <Select
          data-cy="shift.dates.later_earlier"
          virtual={false}
          value={direction}
          onChange={onDirectionChange}
          $width={64}
        >
          {DirectionOptions.map((option) => {
            const translation = translate(
              `task_list.bulk_editor.options.shift_dates.direction.${snakeCase(
                option,
              )}` as TranslationKey,
            );

            return (
              <Select.Option key={option} value={option} title={translation}>
                {translation}
              </Select.Option>
            );
          })}
        </Select>
      </Form.Item>
    </Form>
  );
};
